// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3z0Fq","productName":"Table_productName__3EZg1"};